import React from 'react'
import { CalendarComponent } from '@syncfusion/ej2-react-calendars'
import './Calendar.style.css'

type CalendarProps = {
  value: string | Date
  onChange: (e: { value: Date }) => void
  min?: Date
  max?: Date
}

const Calendar: React.FC<CalendarProps> = ({ value, onChange, min, max }) => {
  return (
    <CalendarComponent
      cssClass="custom-datepicker"
      showTodayButton={false}
      firstDayOfWeek={0}
      dayHeaderFormat="Narrow"
      value={new Date(value)}
      change={onChange}
      {...(min ? { min } : {})}
      {...(max ? { max } : {})}
    />
  )
}

export default Calendar
